
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();


        // Prevent gallery arrows from closing the image viewer
        this.querySelectorAll('.be-gallery-arrow').forEach((button) => {
          button.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
        });

        // Handle gallery arrow clicks
        this.addEventListener('click', (event) => {
          if (event.target.closest('.be-gallery-prev')) {
            event.preventDefault();
            this.changeMedia(-1);
          }

          if (event.target.closest('.be-gallery-next')) {
            event.preventDefault();
            this.changeMedia(1);
          }
        });

        // Allow keyboard navigation
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.changeMedia(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.changeMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Get all product photographs and media
      getMediaItems() {
        const content = this.querySelector(
          '.product-media-modal__content'
        );

        if (!content) return [];

        return Array.from(content.children).filter(
          (item) => item.hasAttribute('data-media-id')
        );
      }

      // Show the image the customer clicked
      showActiveMedia() {
        const items = this.getMediaItems();

        if (!items.length) return;

        const requestedId = this.openedBy?.getAttribute(
          'data-media-id'
        );

        const index = items.findIndex(
          (item) =>
            item.getAttribute('data-media-id') === requestedId
        );

        this.activateMedia(index >= 0 ? index : 0);
      }

      // Display one image and hide the others
      activateMedia(index) {
        const items = this.getMediaItems();

        if (!items.length) return;

        this.currentMediaIndex =
          (index + items.length) % items.length;

        items.forEach((item, itemIndex) => {
          const isActive =
            itemIndex === this.currentMediaIndex;

          item.classList.toggle('active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
        });

        const activeMedia = items[this.currentMediaIndex];

        // Preserve Shopify's existing video loading
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template')
        ) {
          activeMedia.loadContent();
        }

        // Update the image counter
        const counter = this.querySelector(
          '.be-gallery-counter'
        );

        if (counter) {
          counter.textContent =
            `${this.currentMediaIndex + 1} / ${items.length}`;
        }

        // Hide arrows when there is only one image
        this.querySelectorAll('.be-gallery-arrow').forEach(
          (button) => {
            button.hidden = items.length <= 1;
          }
        );
      }

      // Move to the previous or next photograph
      changeMedia(direction) {
        this.activateMedia(
          (this.currentMediaIndex ?? 0) + direction
        );
      }
    }
  );
}
